import Link from 'next/link'

import { H4, Text } from '../../../styles/typography'
import Endorsements from '../../endorsements'
import FoldedText from '../../folded-text'
import { InfoEl } from '../elements'
import ArtistInfoStore from '../stores/artist-info-store'

const Info = () => {
  const {
    data: {
      profile: { name, description, endorsements },
    },
    livdemyId,
  } = ArtistInfoStore.useContainer()

  return (
    <InfoEl>
      <Link href={`/${livdemyId}`} passHref>
        <a>
          <H4>{name}</H4>
        </a>
      </Link>
      <Endorsements data={endorsements} />
      <FoldedText component={Text} maxLines={8}>
        {description}
      </FoldedText>
    </InfoEl>
  )
}

export default Info
